import { pluralize } from "../helpers/index.js";

export const getItemTypeTitle = (containerType: string, count: number = 1) => {
  let title = containerType;

  switch (containerType) {
    case "draught":
      title = "draught item";
      break;

    case "packagedItem":
      title = "packaged item";
      break;

    case "plasticKeg":
      title = "plastic keg";
      break;

    case "steelKeg":
      title = "steel keg";
      break;

    case "bagInBox":
      title = "bag in box";
      break;
  }

  return pluralize(title, count);
};
